import { NgModule } from "@angular/core";
import { SearchPipe } from "./search";

@NgModule({
    declarations: [SearchPipe],
    exports: [SearchPipe]
})
export class PipesModule {}